// Backoffice entry. Boots TanStack Query + TanStack Router; the actual
// app shell lives in `AdminLayout` and the routes in `./router.tsx`.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider } from './lib/auth';
import { router } from './router';
import { initBackofficeSentry } from './lib/sentry';
import './styles.css';

initBackofficeSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Backoffice data is mostly stable per session; stale-while-revalidate
      // semantics with a generous staleTime keeps the UI snappy.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing from index.html');

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
